<template>
    <v-container fill-height style="background-color: #FAFAFA;">
      <v-row justify="center" align="center" class="text-center" style="height: 100vh;">
        <div>
          <v-img src="@/assets/notFound.png" style="max-width: 350px; margin: 0 auto;"/>
          <p class="text-h5" style="font-weight: 600; color: #0A7EA5; margin-top: 30px;">
            Sorry, you cannot view this page.
          </p>
          <p class="text-h6">You have no permission to access this page.</p>
          <p class="text-h6" style="margin-top: -10px;">To access, please contact the administrator.</p>
        </div>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import api from "@/services/api";
  import { server } from "../services/constants";
  import StockCard from "@/components/cards/StockCard";
  
  export default {
    name: "Dashboard",
    data() {
      return {
        search: "",
        selectedProductId: "",
        confirmDeleteDlg: false,
        mDataArray: [],
        fullPage: true,
        headers: [
          {
            text: "Id",
            align: "left",
            sortable: false,
            value: "id",
          },
          { text: "Image", value: "image" },
          { text: "Name", value: "name" },
          { text: "Price", value: "price" },
          { text: "Stock", value: "stock" },
          { text: "Action", value: "action" },
        ],
        username_show: localStorage.getItem(server.FULLNAME),
      };
    },
    components: {
      StockCard,
    },
    async mounted() {
      await api.checkVersion();
      // let yourUrlString = window.location;
      // alert(yourUrlString);
  
      // let parser = document.createElement("a");
      // parser.href = yourUrlString;
  
      // parser.protocol; // => "http:"
      // parser.hostname; // => "example.com"
      // parser.port; // => "3000"
      // parser.pathname; // => "/pathname/"
      // parser.search; // => "?search=test"
      // parser.hash; // => "#hash"
      // parser.host; // => "example.com:3000"
  
      // alert(parser.pathname);
  
      const userId = localStorage.getItem(server.USER_ID);
      if (userId && api.isLoggedIn()) {
      //  await api.checkttoken();
        // this.$router.push("/");
      } else {
        this.$store.state.isLogged = false;
        this.$router.push("/login");
      }
      localStorage.setItem(server.MODELMENU, 0);
      // console.log("Login mounted : " + api.isLoggedIn());
      // console.log("Login mounted : " + userId);
      // await this.loadProducts();
      // this.$showLoader();
      this.$hideLoader();
    },
    methods: {

    },
    beforeCreate() {
      console.log("beforeCreate");
      this.$store.state.navMenu = true;
    },
  };
  </script>
  
  <style></style>
  